<template>
  <div id="app">
    <v-header/>
    <router-view class="page"/>
    <v-footer class="footer"/>
    <contact-modal v-model="modal"/>
    <scroll-top/>
  </div>
</template>

<script>
import VHeader from '@/components/header.vue';
import VFooter from '@/components/footer.vue';
import ContactModal from '@/components/contact-modal';
import ScrollTop from '@/components/scroll-top';
import { mapState } from 'vuex';
import axios from "axios";

export default {
  name: 'app',
  components: { VHeader, VFooter, ContactModal, ScrollTop },
  data: () => ({
    modal: false,
  }),
  mounted() {
      axios.get('https://api.my2ndpassport.com/getproducts').then(response => {
          this.$store.commit('setData', response.data);
          this.$store.commit('websiteDataLoaded');
      })
  },
}
</script>

<style lang="scss">
@import '@/assets/mixins.scss';

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 64px;

  .footer {
    margin-top: auto;
  }
}

html, body {
  overflow-x: hidden;
}

body {
  margin: 0;
  font-family: 'Montserrat', sans-serif;
  -webkit-tap-highlight-color: transparent;
  color: #484848;
}

* {
  box-sizing: border-box;
}

h1, h2, h3 {
  margin: 0;
  color: #131e43;
}

h1 {
  font-size: 48px;
  line-height: 56px;

  @include mobile {
    font-size: 32px;
    line-height: 40px;
  }
}

h2 {
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
}

h3 {
  font-size: 20px;
  line-height: 28px;
}

p, ul {
  font-size: 16px;
  line-height: 24px;
}

.p p{
  font-size:14px;
}

ul, p, h1, h2, h3 {
  margin: 0;

  &:not(:last-child) {
    margin-bottom: 25px;
  }
}

.cg {
  max-width: 1170px;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

ul {
  padding-left: 0;
  list-style: none;
  font-size: 14px;

  li {
    margin-bottom: 10px;

    &:before {
      content: '—';
      margin-right: 10px;
    }
  }
}

img {
  max-width: 100%;
}

a.button {
  padding: 15px 50px !important;
}

button, a.button {
  padding: 0 50px;
  height: 50px;
  font-family: inherit;
  background: transparent;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 700;
  outline: none;
  cursor: pointer;
  transition: all 0.3s;

  &.green {
    border: 2px solid #83ca54;
    color: #484848;

    &:hover,
    &.fill {
      background: #83ca54;
      color: #fff;
    }
  }

  &.white {
    border: none;
    color: #484848;
    background: #fff;
  }
}

.animate {
  transition: all 0.5s ease-in-out;
}

.fade {
  opacity: 0;

  &.animate-active {
    opacity: 1;
  }
}

.slide-up {
  transform: translateY(100px);

  &.animate-active {
    transform: translateY(0);
  }
}

.slide-right {
  transform: translateX(300px);

  &.animate-active {
    transform: translateX(0);
  }
}

.slide-left {
  transform: translateX(-300px);

  &.animate-active {
    transform: translateX(0);
  }
}
html {
  overflow-y: scroll;
}
</style>
